<!-- add-product-dialog.component.html -->
<h2 mat-dialog-title class="dialog-title">
    <mat-icon class="dialog-icon">{{ isEditMode ? 'edit' : 'add_circle' }}</mat-icon>
    {{ isEditMode ? 'Edit Product' : 'Add New Product' }}
  </h2>
  

<mat-dialog-content [formGroup]="productForm">
  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Product Name</mat-label>
    <input matInput formControlName="name" required />
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description"></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Price</mat-label>
    <input matInput formControlName="price" type="number" />
  </mat-form-field>

  <mat-slide-toggle formControlName="is_on_sale">On Sale</mat-slide-toggle>

  <mat-form-field *ngIf="productForm.get('is_on_sale')?.value" appearance="fill" class="full-width">
    <mat-label>Sale Price</mat-label>
    <input matInput formControlName="sale_price" type="number" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
  <button *ngIf="!isEditMode" mat-raised-button color="primary" (click)="onSubmit()" [disabled]="productForm.invalid">Add</button>
  <button *ngIf="isEditMode" mat-raised-button color="primary" (click)="onSubmit()" [disabled]="productForm.invalid">Update</button>
</mat-dialog-actions>
